// extracted by mini-css-extract-plugin
export default {"element":"DisableBack_element__VN31m"};